import { takeLatest } from 'redux-saga/effects'
import {
  FETCH_ADMIN,
  GET_INVOICES,
  REMOVE_USER,
  REPLACE_USER,
  REPLACE_USER_SUBSCRIPTION,
  SUBSCRIBE_USER,
  UNSUBSCRIBE_USER,
} from '../actions'
import { getAdminHandler } from './admin'
import { unsubscribeUserHandler } from './unsubscribeUser'
import { replaceUserHandler } from './replaceUser'
import { subscribeUserHandler } from './subscribeUser'
import { removeUserHandler } from './removeUser'
import { replaceUserSubscriptionHandler } from './replaceUserSubscription'
import { getInvoicesHandler } from './getInvoices'

export default function* adminDashboardData() {
  yield takeLatest(FETCH_ADMIN.action, (action) =>
    getAdminHandler(action.payload),
  )
  yield takeLatest(SUBSCRIBE_USER.action, (action) =>
    subscribeUserHandler(action.payload),
  )
  yield takeLatest(UNSUBSCRIBE_USER.action, (action) =>
    unsubscribeUserHandler(action.payload),
  )
  yield takeLatest(REPLACE_USER.action, (action) =>
    replaceUserHandler(action.payload),
  )
  yield takeLatest(REMOVE_USER.action, (action) =>
    removeUserHandler(action.payload),
  )
  yield takeLatest(REPLACE_USER_SUBSCRIPTION.action, (action) =>
    replaceUserSubscriptionHandler(action.payload),
  )
  yield takeLatest(GET_INVOICES.action, (action) =>
    getInvoicesHandler(action.payload),
  )
}
